

export function snackbarReducer(state, action) {
    const set = action['set']
    if(set === 'add') {
        return [...state, action]
    }
    else if(set === 'remove') {
        return state.filter(x => x['id'] !== action['id'])
    }

    return state
}